export default __webpack_public_path__ + "static/media/4.d78244a3.jpg";